import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * ModuleSettings component styles
 * @returns {Function}
 */

export const useStyles = makeStyles((theme) =>
  createStyles({
    moduleSettings: {
      height: '100%',
    },

    header: {
      textAlign: 'left',
    },

    titleWrapper: {
      padding: '0 1.6rem 2rem 0',
    },

    title: {
      '&&': {
        alignItems: 'center',
        color: variables.colorV2.text.header,
        display: 'flex',
        fontSize: '2rem',
        fontWeight: 400,
        justifyContent: 'space-between',
        lineHeight: '2.5rem',
        // paddingBottom: '1rem',
      },
    },

    elementName: {
      '&&': {
        fontWeight: 800,
      },
    },

    panel: {
      background: variables.colorV2.panel.background.default,
      borderRadius: '2rem',
      display: 'flex',
      flexDirection: 'column',
      maxHeight: '100%',
      overflow: 'auto',
      padding: '2rem 1.6rem',

      '& .MuiAccordion-root': {
        marginBottom: '2rem',
        overflowY: 'scroll',
      },

      '& .MuiFormControlLabel-root': {
        marginLeft: 0,
      },
    },

    editModule: {
      // marginRight: theme.spacing(1),
      // width: '100%',
    },

    panelTitleHeading: {
      marginBottom: theme.spacing(0.5),
    },

    renameBar: {
      display: 'flex',
      // alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: '100%',
    },

    renameField: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
    },

    renameBarButtons: {
      display: 'flex',
      gap: '1rem',
    },

    tabsWrapper: {
      background: variables.color.primary.backgroundLightestGray,
      borderTop: `${variables.borderWidth.md} solid ${variables.color.primary.lightGray}`,
      borderBottom: `${variables.borderWidth.md} solid ${variables.color.primary.lightGray}`,
    },

    tabs: {
      display: 'inline-flex',
      minHeight: 'unset',
      borderTop: `${variables.borderWidth.md} solid ${variables.color.primary.lightGray}`,
      marginTop: '-1px',
      marginBottom: '-2px',
    },

    tab: {
      minHeight: 'unset',
      textTransform: 'none',
      fontSize: variables.font.size.xs,
      fontWeight: variables.font.weight.medium,
      lineHeight: variables.lineHeight.md,
      color: variables.color.primary.mediumGray,
      background: variables.color.primary.backgroundLightestGray,
      border: `${variables.borderWidth.md} solid transparent`,
    },

    selectedTab: {
      background: variables.color.primary.white,
      textTransform: 'none',
      borderRight: `${variables.borderWidth.md} solid ${variables.color.primary.lightGray}`,
      borderBottom: 'none',
    },

    tabWrapper: {
      flexDirection: 'row',

      '&&': {
        '& > *:first-child': {
          marginRight: theme.spacing(1),
          marginBottom: '0',
        },
      },
    },

    editIcon: {
      marginRight: theme.spacing(0.75),
    },

    content: {
      flex: '1 1 auto',
      // height: '100%',
      minHeight: 0,
      overflowY: 'auto',
    },

    editModeContainer: {
      padding: '2rem 1.6rem 2rem 1.6rem',
    },

    buttonContainer: {
      // alignSelf: 'flex-end',
      display: 'flex',
      justifyContent: 'flex-start',
      marginTop: 'auto',
      // minWidth: '60rem',
      // width: '60rem',
    },

    save: {
      // marginLeft: 'auto',
      '&:disabled': {
        // backgroundColor: variables.color.primary.backgroundLighterGray,
        // border: `0.1rem solid ${variables.color.primary.lightGrayDarker}`,
        // color: variables.color.primary.lightGrayDarker,
      },
    },

    close: {
      '&&': {
        borderRadius: '3.2rem',
        fontWeight: 500,
        marginRight: '.8rem',
        // border: `1px solid ${variables.colorV2.button.contained.secondary.border.default}`,
        // color: variables.colorV2.button.contained.secondary.text.default,

        '&:hover': {
          // backgroundColor: variables.colorV2.button.contained.secondary.background.hover,
          // border: `1px solid ${variables.colorV2.button.contained.secondary.border.hover}`,
          // color: variables.colorV2.button.contained.secondary.text.hover,
        },
      },
    },
  }),
);
